// extracted by mini-css-extract-plugin
module.exports = {"viewport":"W3PKNSCwGaUw3jqG7zcoQQ=="};